export const CSV_SUCCESS_MESSAGE = 'CSVを出力しました。';
export const CSV_ERROR_MESSAGE = 'CSVの出力に失敗しました。';
export const EMPTY_TEXT_FILTERED = '該当する検索結果がありません。';

export const UPDATE_SUCCESS_MESSAGE = '更新が正常に終了しました。';
export const UPDATE_ERROR_MESSAGE = '更新ができませんでした。';
export const DELETE_SUCCESS_MESSAGE = '削除しました。';
export const DELETE_COMPLETED_MESSAGE = '削除が正常に終了しました。';
export const DELETE_ERROR_MESSAGE = '削除に失敗しました。';
export const DELETE_CONFIRM_DATA_MESSAGE = 'このデータを削除してよろしいですか？';
export const PDF_ERROR_MESSAGE = 'PDFの生成に失敗しました。';

export const UPLOAD_SUCCESS_MESSAGE = 'アップロードしました。';
export const UPLOAD_ERROR_MESSAGE = 'アップロードに失敗しました。';
export const DOWNLOAD_ERROR_MESSAGE = 'ダウンロードに失敗しました。';
export const FILE_FETCH_ERROR_MESSAGE = 'ファイルの取得に失敗しました。';

export const SERVER_ERROR_MESSAGE = 'エラーが発生しました。しばらくしてからもう一度お試しください。';
